"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripDriverVehicle = void 0;
class TripDriverVehicle {
    title;
    color;
    licensePlate;
}
exports.TripDriverVehicle = TripDriverVehicle;
//# sourceMappingURL=TripDriverVehicle.js.map